type FetchIsFreemiumOptions = {
  email?: string
  userId?: number
}

export async function fetchIsFreemiumStatus(
  options?: FetchIsFreemiumOptions
): Promise<boolean> {
  try {
    const params = new URLSearchParams()
    if (options?.email) params.set('email', options.email)
    if (options?.userId) params.set('userId', options.userId.toString())

    const url = `/api/user/is-freemium${params.toString() ? `?${params}` : ''}`
    const res = await fetch(url)
    if (!res.ok) return false

    const data = (await res.json()) as { isFreemium: boolean }
    return data.isFreemium || false
  } catch {
    return false
  }
}
